import { render, staticRenderFns } from "./ApplianceStatusWidget.vue?vue&type=template&id=067ff812"
import script from "./ApplianceStatusWidget.vue?vue&type=script&lang=js"
export * from "./ApplianceStatusWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports